import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-two-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title title-delai" }
const _hoisted_4 = { class: "width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('intervention.steptwo.label.type')), 1)
    ]),
    _createVNode(_component_DropDown, {
      display: _ctx.diplayType,
      label: _ctx.$t('intervention.steptwo.label.type'),
      list: _ctx.types,
      selectedItem: _ctx.selectedType,
      class: "width",
      onSelect: _ctx.selectType
    }, null, 8, ["display", "label", "list", "selectedItem", "onSelect"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('intervention.steptwo.label.delai')), 1),
      _createVNode(_component_ReglePastille, { cle: "demandeIntervention.delaiIntervention" })
    ]),
    _createVNode(_component_DropDown, {
      display: _ctx.diplayType,
      label: _ctx.$t('intervention.steptwo.label.delai'),
      list: _ctx.selectedType ? _ctx.selectedType.delais : [],
      selectedItem: _ctx.selectedDelai,
      class: "width",
      onSelect: _ctx.selectDelai
    }, null, 8, ["display", "label", "list", "selectedItem", "onSelect"]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.selectedDelai && _ctx.selectedDelai.isAutre)
        ? (_openBlock(), _createBlock(_component_DatePicker, {
            key: 0,
            dateMin: _ctx.dateNow,
            dateValue: _ctx.dateAutre,
            label: _ctx.$t('intervention.other.date'),
            onSetDate: _ctx.setDateAutre
          }, null, 8, ["dateMin", "dateValue", "label", "onSetDate"]))
        : _createCommentVNode("", true)
    ])
  ]))
}